import { Heading2 } from '@entur/typography';
import Autosuggest from '~/components/Autosuggest/Autosuggest';
import * as React from 'react';
export default {
  Heading2,
  Autosuggest,
  React
};